var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21.45 0H4.55A4.55 4.55 0 000 4.55v16.9A4.55 4.55 0 004.55 26h16.9A4.55 4.55 0 0026 21.45V4.55A4.55 4.55 0 0021.45 0z","fill":"#6C40FD","key":0}),React.createElement("path",{"d":"M22.389 11.842h-4.263V8.714c0-.765.912-.823 1.193-.823h2.9v-4.28h-2.9c-3.21 0-5.627 2.194-5.627 5.103v3.128h-3.58v4.28h3.58V26h4.434v-9.878h3.58l.683-4.28z","fill":"#fff","key":1})]);
}

FacebookIcon.defaultProps = {"width":"26","height":"26","fill":"none"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
